import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldAlt,
  faFingerprint,
  faUserLock,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

interface PermissionErrorModalProps {
  show: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

const PermissionErrorModal: React.FC<PermissionErrorModalProps> = ({
  show,
  onClose,
  title = "Acesso Negado",
  message = "Você não possui as permissões necessárias para esta ação",
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="permission-modal"
      contentClassName="border-0 shadow-lg"
    >
      <div className="position-relative bg-body-emphasis rounded-lg overflow-hidden">
        {/* Top decorative element */}
        <div
          className="position-absolute w-100"
          style={{
            top: 0,
            left: 0,
            height: "6px",
            background:
              "linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899)",
          }}
        ></div>

        {/* Floating security graphic */}
        <div
          className="position-absolute"
          style={{
            top: "15px",
            right: "15px",
            opacity: 0.06,
          }}
        >
          <FontAwesomeIcon icon={faFingerprint} className="fa-5x" />
        </div>

        {/* Content */}
        <div className="p-5">
          {/* Icon and title section */}
          <div className="d-flex align-items-center mb-4">
            <div
              className="rounded-circle me-3 d-flex align-items-center justify-content-center"
              style={{
                background: "linear-gradient(45deg, #ef4444, #f97316)",
                width: "52px",
                height: "52px",
                boxShadow: "0 10px 15px -3px rgba(239, 68, 68, 0.3)",
              }}
            >
              <FontAwesomeIcon
                icon={faUserLock}
                className="text-white fa-lg"
              />
            </div>
            <div>
              <h4 className="mb-0 fw-bold">{title}</h4>
              <p className="text-muted mb-0 small">
                Erro: 403 - Acesso Negado
              </p>
            </div>
          </div>

          {/* Message */}
          <div className="mb-4">
            <p className="lead mb-0">{message}</p>
          </div>

          {/* Info box */}
          <div
            className="rounded-3 p-4 mb-4"
            style={{
              background: "rgba(59, 130, 246, 0.05)",
              border: "1px solid rgba(59, 130, 246, 0.1)",
            }}
          >
            <div className="d-flex mb-3">
              <div
                className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                style={{
                  background: "rgba(59, 130, 246, 0.1)",
                  width: "34px",
                  height: "34px",
                }}
              >
                <FontAwesomeIcon icon={faShieldAlt} className="text-primary" />
              </div>
              <h6 className="mb-0 fw-bold d-flex align-items-center">
                O que fazer agora?
              </h6>
            </div>

            <ul className="ps-4 mb-0">
              <li className="mb-2">
                Entre em contato com seu administrador para solicitar o acesso
                necessário
              </li>
              <li className="mb-2">
                Verifique se você está utilizando a conta correta
              </li>            
            </ul>
          </div>

          {/* Actions */}
          <div className="d-flex align-items-center">
            <button
              onClick={onClose}
              className="btn border-0 text-muted me-3"
            >
              Cancelar
            </button>

            <button
              onClick={onClose}
              className="btn text-white px-4 py-2 flex-grow-1"
              style={{
                background: "linear-gradient(90deg, #3b82f6, #8b5cf6)",
                border: "none",
                boxShadow: "0 10px 15px -3px rgba(59, 130, 246, 0.3)",
              }}
            >
              Entendi
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PermissionErrorModal;
